import { render, staticRenderFns } from "./BloqueRedes.vue?vue&type=template&id=3c60f908&scoped=true"
import script from "./BloqueRedes.vue?vue&type=script&lang=js"
export * from "./BloqueRedes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c60f908",
  null
  
)

export default component.exports